module.exports = __webpack_public_path__ + "img/3f_sense.acbd273a.svg";